<template>
    <el-dialog
        title="提示"
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form >
          <div class="val"> 1、<div style="background-color: #15C377;" class="icon" > </div> 表示当天有进出打卡记录，视为全勤；</div>
          <div class="val">2、<div style="background-color: #0AB1A1;" class="icon" > </div> 表示当天有进或出打卡记录，视为出勤</div>
          <div class="val">3、<div style="background-color:#F96868 ;" class="icon" > </div> 表示当天无打卡记录，视为缺勤</div>
          <div class="val">PS:无</div>
        </el-form>
        
    </el-dialog>
</template>
<script>
export default {
    components: {
    },
    data() {

        return {
            dialogVisible: true,
            loading:false,
            title:'',
            form:{
                imei:'',
            },
 
          
        }

    },
    created(){
       
    },
    mounted(){
            
    },
    methods:{
        handleClose() {
            this.$emit('closeBtn')
      },
    }
     
    }




</script>
<style  scoped lang="scss">
    .val{
        margin-bottom: 20px;
        display: flex;
        .icon{
            width: 13px;
            height: 20px; 
            background-color: pink;
            border-radius: 3px;
        }
    }
</style>